'use client';

import { StaticImageData } from 'next/image';
import { useParams } from 'next/navigation';
import React, { FC, useCallback, useEffect, useState } from 'react';

import { GameType } from '@/api/services/GameService/types';
import GlobalService from '@/api/services/GlobalService';
import GameCard from '@/app/[lang]/(web)/products/land-based/components/CabinetCard/components/GameCard';
import Image from '@/components/core/Image';
import { useTranslation } from '@/hooks/useTranslations';

import './style.scss';

type CabinetCardProps = {
  img: StaticImageData;
  title: string;
  description: string;
  isGameSelection?: boolean;
  index: number;
};

const CabinetCard: FC<CabinetCardProps> = ({
  img,
  title,
  description,
  isGameSelection = false,
  index,
}) => {
  const [page, setPage] = useState(1);
  const [games, setGames] = useState<GameType[] | []>([]);
  const params = useParams();
  const [noMoreGames, setNoMoreGames] = useState<boolean>(false);
  const { t } = useTranslation();

  const getGames = useCallback(() => {
    if (isGameSelection && !noMoreGames) {
      GlobalService.getData<GameType>('GAME_URL_FRONT', {
        page: page,
        perPage: 8,
        category: '',
        lang: params.lang,
        land_based: 1,
      }).then((data) => {
        if (data.query) {
          if (data.query.length < 8) setNoMoreGames(true);
          setGames((prev) => [...prev, ...data.query]);
        } else setNoMoreGames(true);
      });
    }
  }, [isGameSelection, page, params, noMoreGames]);

  useEffect(() => {
    getGames();
  }, [getGames]);

  return (
    <div className="our-cabinets-item-block" id={isGameSelection ? 'games' : undefined}>
      <div className={`our-cabinets-item type${index + 1}`}>
        <div className="our-cabinets-item-left">
          <Image src={img} alt="" />
        </div>
        <div className="our-cabinets-item-right">
          <h3 className="our-cabinets-item-right-title">{t(title)}</h3>
          <p className="our-cabinets-item-right-info">{t(description)}</p>
        </div>
      </div>
      {isGameSelection && (
        <div className="our-cabinets-open-block">
          <div className="our-cabinets-game-wrp">
            {games.map((game, index) => (
              <GameCard game={game} key={index} />
            ))}
          </div>
          <div className="our-cabinets-btn-wrp">
            <button
              className="button btnTypeMedium btnTypeGray fullWidth"
              id="land-based-show-more"
              onClick={() => {
                if (!noMoreGames) {
                  setPage((prev) => prev + 1);
                } else {
                  setPage(1);
                  setGames([]);
                  setNoMoreGames(false);
                }
              }}
            >
              <p>{!noMoreGames ? t('LandBased-Benefit Button') : t('Showless-Button')}</p>
              {/*<i className="bc-i-go-to btnIcon btnIconSmall"/>*/}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CabinetCard;
